// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1S-YY","footer":"styles_footer__3Gzgs"};